import { Paper, styled } from '@mui/material';

export const PaperBox = styled(Paper)(({ theme }) => {
    return {
        boxShadow: 'unset',
        minWidth: '25rem',
        height: '100%',
        overflow: 'auto',
        padding: `${theme.typography.generic.xxxLarge}`,

        [theme.breakpoints.down('md')]: {
            minWidth: '100%',
            width: '100%',
            padding: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
        },

        [theme.breakpoints.down('sm')]: {
            minWidth: '100%',
            width: '100%',
            padding: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
        },
    };
});

// for navigationItem components

export const NavigateListItemStyled = styled('li')(({ theme }) => {
    return {
        borderRadius: theme.typography.borderRadius.xLarge,
        backgroundColor: theme.palette.background.paper,
        padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.medium}`,
    };
});

export const IconBox = styled('div')(({ theme }) => {
    return {

        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',

        // padding: `${theme.typography.generic.xSmall}`,
        
        
        "& .MuiSvgIcon-root":{
            color:theme.palette.icon.brandPrimary,
            fontSize:"1rem"
        }

        // borderRadius: theme.typography.borderRadius.small,

        // fontSize: theme.typography.customFontSize.xLarge,

        // '& svg': {
        //     width: 20,
        //     height: 20,
        //     // color:theme.palette.icon.brandPrimary
        // },
    };
});
